const reportWebVitals = onPerfEntry => {
  // Check cookie consent before tracking
  const hasAnalyticsConsent = () => {
    try {
      // Check if localStorage is available
      if (typeof window === 'undefined' || !window.localStorage) {
        return false;
      }

      const stored = localStorage.getItem('cookieConsent');
      if (stored) {
        const parsed = JSON.parse(stored);
        // Check if consent is expired (1 year)
        const expiryDate = new Date(parsed.timestamp);
        expiryDate.setDate(expiryDate.getDate() + 365);
        if (new Date() > expiryDate) {
          return false;
        }
        return parsed.analytics === true;
      }
      return false;
    } catch (error) {
      return false;
    }
  };

  // Only track if analytics consent is given
  if (!hasAnalyticsConsent()) {
    return;
  }

  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
